import { gql } from '@apollo/client';

export default gql`
  query generalSettings($subDomain: String) {
    generalSettings(subDomain: $subDomain) {
      accountEmail
      banner {
        image
        position
      }
      bannerHeight
      billable
      childrenDescriptionLabel
      childrenNameLabel
      childrenStatusLabel
      completed
      completedCount
      cssOverwrite
      customFields {
        customFieldId
        fieldName
        fieldType
        numberDecimalRounding
        numberPrefix
        numberSuffix
        numberThousandSeparator
        planningStructureId
      }
      customSubDomain
      discontinued
      discontinuedCount
      displayClonedActions
      displayLevel
      displayLinkedProjects
      displayLowestLevelDates
      drilldownable
      enableIpList
      fontFamily
      fontSize
      footer
      footerBackgroundColor
      googleTracking
      translateProvider
      isA11yMode
      translateProvider
      headerBackgroundColor
      hideCustomFields
      hideTags
      horizontalPadding
      interfaceAddress
      ipWhiteList
      logo {
        image
      }
      logoLink
      majorDisruption
      majorDisruptionCount
      measureColumns
      name
      navPosition
      navTextColor
      newerUpdatesAvailable
      notificationType
      onTrack
      onTrackCount
      overdueCount
      pageTitle
      planName
      progressPercentage
      publishedAt
      reportingDates
      showChecklist
      showCompleted
      showCustomFields
      showDiscontinued
      showIndicatorOnHeader
      showLatestUpdate
      showLinkedProjectBudget
      showLinkedProjectExpenditure
      showLinkedProjectPhase
      showMajorDisruption
      showMeasureDetail
      showMinorDisruption
      showOnTrack
      showProgress
      showStatusBar
      showStatusPending
      showTags
      showUpcoming
      someDisruption
      someDisruptionCount
      startOfFinancialYear
      statusPending
      statusPendingCount
      subDomain
      syncRequestedAt
      syncSettings {
        amPmGenerated
        autoSync
        frequency
        monthlyEachDates
        monthlyEvery
        monthlyMode
        monthlyOnTheDayOption
        monthlyOnTheFirstLastOption
        reportingDateBeforeAfter
        reportingDateDays
        syncType
        timeGenerated
        weeklyEvery
        weeklyOn
      }
      syncStartOn
      syncStatus
      tags {
        colorCode
        labelColor
        tagId
        tagName
      }
      timeZone
      timeZoneName
      unpublishedAt
      upcoming
      upcomingCount
      rootLevel
    }
  }
`;
